import { gql } from '@apollo/client';
export const getAnswersForQuestions = gql`
    query getAnswersForQuestions(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filtersA: JSONString!
        $filtersB: JSONString!
        $filtersC: JSONString!
        $questionKey: Int!
        $limit: Int!
        $offset: Int!
    ) {
        getAnswersForQuestions(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filtersA: $filtersA
            filtersB: $filtersB
            filtersC: $filtersC
            questionKey: $questionKey
            limit: $limit
            offset: $offset
        ) {
            data {
                attributeType
                questionsData {
                    questionKey
                    scoreData {
                        promoKey
                        promoName
                        score
                        colorsData {
                            R
                            G
                            B
                        }
                    }
                }
            }
            meta {
                count
            }
        }
    }
`;

export const getAnswersForQuestionsPpgLvl = gql`
    query getAnswersForQuestionsPpgLvl(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filtersA: JSONString!
        $filtersB: JSONString!
        $questionKey: Int!
        $limit: Int!
        $offset: Int!
    ) {
        getAnswersForQuestionsPpgLvl(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filtersA: $filtersA
            filtersB: $filtersB
            questionKey: $questionKey
            limit: $limit
            offset: $offset
        ) {
            data {
                attributeType
                questionsData {
                    salesValueData {
                        score
                        colorsData {
                            R
                            G
                            B
                        }
                    }
                    salesVolumeData {
                        score
                        colorsData {
                            R
                            G
                            B
                        }
                    }
                    questionKey
                    scoreData {
                        promoKey
                        promoName
                        score
                        colorsData {
                            R
                            G
                            B
                        }
                    }
                }
            }
            meta {
                count
            }
        }
        # debug: _debug {
        #     sql {
        #         sql
        #         duration
        #     }
        # }
    }
`;
